/**
 * @file Creates the destination form for a dropped-file import. Calls the
 * existing `createForm` callable (which atomically creates the form and its
 * first version, setting `currentVersionId`) and reads that version id back so
 * the caller has the `{ formId, formVersionId }` pair needed to bind an agent
 * import run to a `formVersion` page. Used by `AIProvider.startDocumentImportRun`.
 */
import { doc, getDoc } from 'firebase/firestore';
import type { Form } from '#types';
import { firestore } from './startFirestore';
import { createForm } from './artifactFunctions';

export interface ImportFormBinding {
  formId: string;
  formVersionId: string;
}

export async function createImportForm(formType: string, title: string): Promise<ImportFormBinding> {
  const formId = await createForm({ formType, title });
  const snapshot = await getDoc(doc(firestore, 'forms', formId));
  const formVersionId = (snapshot.data() as Form | undefined)?.currentVersionId;
  if (!formVersionId) {
    throw new Error(`Created form ${formId} has no current version`);
  }
  return { formId, formVersionId };
}
